const HOSPITAL_STATS_CHART_PROPS = {
  patientAgeGroup: {
    dataLabels: ["Child", "Adult", "Adolescent"],
    colors: ["#1976d2", "#2e7d32", "#ff9800"],
    legend: {
      show: false,
    },
  },
  referralSources: {
    title: "Referral Sources",
    dataLabels: [
      "Physician / Specialist",
      "Word of Mouth",
      "Instagram",
      "Facebook",
      "Internet Search",
      "Podcast",
      "iHeart Radio",
      '"Disconnected Kids" Book',
      "Other",
    ],
    colors: [
      "#1976d2",
      "#2e7d32",
      "#ff9800",
      "#1565c0",
      "#7b1fa2",
      "#f44336",
      "#00838f",
      "#5d4037",
      "#9e9e9e",
    ],
    legend: {
      show: false,
    },
  },
  doctorAsmtForms: {
    title: "Doctor Assessments Completed",
    width: 450,
    xaxis: {
      title: "",
      categories: [""],
    },
    yaxis: {
      min: 0,
      max: undefined,
      title: "Count",
    },
    annotations: {
      yaxis: [],
    },
  },
  enrollmentSessions: {
    title: "Enrollment Sessions Completed",
    width: 450,
    xaxis: {
      title: "",
      categories: [""],
    },
    yaxis: {
      min: 0,
      max: undefined,
      title: "Count",
    },
    annotations: {
      yaxis: [],
    },
  },
};
export default HOSPITAL_STATS_CHART_PROPS;
